<template>
  <zen-one :showuserinfo="false" :crumbs="crumbs" title="">
      <div class="mb3 text-left">
         <span class="no_permohonan">{{data.no_permohonan}}</span> | <w-tag class="mr4" bg-color="primary" round> {{data.status_keterangan}} </w-tag>
      </div>
    <z-page title="Maklumat Permohonan" >
      <div class="table_scrol">
        <table class="w-table" color="light" style="width: 100%; margin: 0;">
          <tbody><tr><td>
           <w-card bg-color="" class="">
             <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
               <div class="w-flex wrap smd-column">
                 <div class="grow xs12" style="line-height: 15px">
                   <table style="width: 100%; border-collapse: collapse;">
                    <tbody>
                     <tr class="row_data">
                       <td style="text-align: left; width: 40%; white-space: nowrap;">
                         <b>ID Premis</b>&nbsp;: {{data.no_nama_premis}}
                       </td>
                       <td style="text-align: left; width: 40%; white-space: nowrap;">
                         <b>Jenis Ternakan</b>&nbsp;: {{data.lkp_ternakan}}
                       </td>
                       <td style="text-align: left; width: 40%; white-space: nowrap;">
                         <b>Jenis Baka</b>&nbsp;: {{data.lkp_jenis_baka}}
                       </td>
                     </tr>
                     </tbody>
                   </table>
                 </div>
               </div>
             </w-form>
           </w-card>
           </td></tr></tbody>
         </table>
        <br>
        <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'SENARAI TERNAKAN'">
  <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
    <template #title>
      SENARAI TERNAKAN
    </template>
    <div class="w-table-wrap" style="max-height: 400px;">
      <div class="table-profil-scrol">
        <table class="w-table" color="light">
          <thead>
            <tr>
              <th class="w-table__header text-center" width="1%">BIL</th>
              <th class="w-table__header text-center">NO PENDAFTARAN</th>
              <th class="w-table__header text-center">ID/NAMA TERNAKAN</th>
              <th class="w-table__header text-center">BAKA TERNAKAN</th>
              <th class="w-table__header text-center">ID/NAMA/BAKA BAPA</th>
              <th class="w-table__header text-center">ID/NAMA/BAKA IBU</th>
              <th class="w-table__header text-center">JANTINA</th>
              <th class="w-table__header text-center">TARIKH LAHIR</th>
              <th class="w-table__header text-center">(UMUR BULAN)</th>
              <th class="w-table__header text-center">STATUS DARI PENILAI</th>
              <th class="w-table__header text-center">STATUS PENYEMAK</th>
              <th class="w-table__header text-center">STATUS PELULUS</th>
              <th class="w-table__header text-center" width="10%">TINDAKAN</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(dt, ind) in data.ternakan_list" :key="dt.id">
              <tr class="w-table__row">
                <td class="w-table__cell text-center">{{ind+1}}</td>
                <td class="w-table__cell text-center">{{dt.no_pendaftaran}}</td>
                <td class="w-table__cell text-center">{{dt.ternakan_nama}}</td>
                <td class="w-table__cell text-center">{{dt.lkp_baka}}</td>
                <td class="w-table__cell text-center">{{dt.id_bapa}}</td>
                <td class="w-table__cell text-center">{{dt.id_ibu}}</td>
                <td class="w-table__cell text-center">{{dt.jantina}}</td>
                <td class="w-table__cell text-center">{{$zutil.dateformat(dt.tarikh_lahir)}}</td>
                <td class="w-table__cell text-center">{{$zutil.umurbulan(dt.tarikh_lahir)}}</td>
                <td class="w-table__cell text-center"
                  :style="[ 
                    dt.art_pdbf_status_nama.toLowerCase() === 'lulus' 
                      ? { backgroundColor: '#4CAF50', color: 'white' } 
                      : dt.art_pdbf_status_nama.toLowerCase() === 'gagal' 
                      ? { backgroundColor: '#F44336', color: 'white' } 
                      : dt.art_pdbf_status_nama.toLowerCase() === 'lulus bersyarat' 
                      ? { backgroundColor: '#FFEB3B' } 
                      : {}, 
                    { borderRight: '2px solid white' } 
                  ]">
                  {{ dt.art_pdbf_status_nama.toUpperCase() }}
                </td>
                <td class="w-table__cell text-center" 
                  :style="[ 
                    dt.lkp_baka_saranan_keterangan === 'LULUS KATEGORI A' 
                      ? { backgroundColor: '#4CAF50', color: 'white' } 
                      : dt.lkp_baka_saranan_keterangan === 'LULUS KATEGORI B' 
                      ? { backgroundColor: '#FFEB3B', color: 'black' } 
                      : dt.lkp_baka_saranan_keterangan === 'GAGAL' 
                      ? { backgroundColor: '#F44336', color: 'white' } 
                      : {}, 
                    { borderLeft: '2px solid white' } // <-- pemisah antar kolom
                  ]">
                  {{ dt.lkp_baka_saranan_keterangan }}
                </td>
                <td class="w-table__cell text-center" 
                  :style="[ 
                    dt.lkp_baka_saranan_pelulus_keterangan === 'LULUS KATEGORI A' 
                      ? { backgroundColor: '#4CAF50', color: 'white' } 
                      : dt.lkp_baka_saranan_pelulus_keterangan === 'LULUS KATEGORI B' 
                      ? { backgroundColor: '#FFEB3B', color: 'black' } 
                      : dt.lkp_baka_saranan_pelulus_keterangan === 'GAGAL' 
                      ? { backgroundColor: '#F44336', color: 'white' } 
                      : {}, 
                    { borderLeft: '2px solid white' } // <-- pemisah antar kolom
                  ]">
                  {{ dt.lkp_baka_saranan_pelulus_keterangan }}
                </td>
                <td class="w-table__cell text-center tindakan-cell">
                  <!-- BUTTON EDIT/VIEW - Menggunakan v-if dengan kondisi yang jelas -->
                  <div class="button-group">
                    <!-- Button untuk jantina_id = 1 -->
                    <w-button 
                      v-if="dt.jantina_id == 1"
                      :bg-color="(data.lkp_status_id == 18 || data.lkp_status_id == 21) ? 'primary' : 'warning'"
                      :route="$route('art.semakan.penilaian.bse_show_baka', dt.art_pdbf.art_pdbf_id)" 
                      class="be fs-2 action-button"><div style="width: 8px"></div> 
                      <w-icon md class="mr2">
                        {{ (data.lkp_status_id == 18 || data.lkp_status_id == 21) ? 'fal fa-eye' : 'fal fa-pencil' }}
                      </w-icon>
                    </w-button>
                    
                    <!-- Button untuk jantina_id != 1 -->
                    <w-button 
                      v-if="dt.jantina_id != 1"
                      :bg-color="(data.lkp_status_id == 18 || data.lkp_status_id == 21) ? 'primary' : 'warning'"
                      :route="$route('art.semakan.penilaian.fe_show_baka', dt.art_pdbf.art_pdbf_id)" 
                      class="be fs-2 action-button"><div style="width: 8px"></div> 
                      <w-icon md class="mr2">
                        {{ (data.lkp_status_id == 18 || data.lkp_status_id == 21) ? 'fal fa-eye' : 'fal fa-pencil' }}
                      </w-icon>
                    </w-button>

                    <!-- BUTTON CETAK -->
                      <w-button 
                        v-if="data.lkp_status_id == 18 && $zutil.anyRole(['1', '2', '5']) && dt.lkp_baka_saranan_keterangan !== 'GAGAL' && dt.lkp_baka_saranan_pelulus_id != 3"
                        bg-color="success" 
                        class="be fs-2 action-button" 
                        @click="cetak(dt.id)"><div style="width: 8px"></div> 
                        <w-icon md class="mr2">fal fa-print</w-icon>
                      </w-button>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </w-form>
</w-card>
      <br>
      <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'STATUS KESIHATAN'">
        <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
          <template #title>
            STATUS KESIHATAN
          </template>
         <span class="input-hint">Dokumen Sokongan</span>
          <div class="w-table-wrap" style="max-height: 400px;">
           <div class="table-profil-scrol">
             <table class="w-table" color="light">
               <thead>
                 <tr>
                   <th class="w-table__header text-center" width="1%">BIL</th>
                   <th class="w-table__header text-center">KETERANGAN</th>
                   <th class="w-table__header text-center">NAMA FAIL</th>
                   <th class="w-table__header text-center">NO KES</th>
                 </tr>
               </thead>
               <tbody>
                 <template v-for="(dt, ind) in data.baka_dokumen_list" :key="dt.id">
                   <tr class="w-table__row">
                     <td class="w-table__cell text-center">{{ind+1}}</td>
                     <td class="w-table__cell text-center">{{dt.nama}}</td>
                     <td class="w-table__cell text-center">
                       <a v-if="dt.atthectment_dokumen && dt.atthectment_dokumen.length > 0" 
                          :href="dt.atthectment_dokumen[0].url" 
                          target="_blank" 
                          class="text-blue-500 hover:underline">
                         {{dt.dokumen_nama}}
                       </a>
                       <span v-else>{{dt.dokumen_nama || '-'}}</span>
                     </td>

                     <td class="w-table__cell text-center">
                         <w-tooltip md top color="white" bg-color="black">
                            <template #activator="{ on }">
                                    <a v-on="on" 
                                       @click="url_kes(dt.no_kes)" 
                                       style="text-decoration: underline; color: #3a3ad0;">
                                       {{ dt.no_kes }}
                                    </a>
                            </template>
                                 <span>
                                    https://myvetlab.dvs.gov.my/myvetlabservis/senarai-keputusan-smartfarming.php?no_kes={{ dt.no_kes }}
                                 </span>
                        </w-tooltip>
                      </td>
                   </tr>
                 </template>
               </tbody>
             </table>
           </div>
         </div>
          <span class="input-hint">Verifikasi Penyakit Gerompok</span>
          <div class="w-table-wrap" style="max-height: 400px;">
            <div class="table-profil-scrol">
              <table class="w-table" color="light">
                <thead>
                  <tr>
                    <th class="w-table__header text-center" width="1%">BIL</th>
                    <th class="w-table__header text-center">NAMA</th>
                    <th class="w-table__header text-center">KETERANGAN</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(dt, ind) in data.baka_penyakit_list" :key="dt.id">
                    <tr class="w-table__row">
                      <td class="w-table__cell text-center">{{ind+1}}</td>
                      <td class="w-table__cell text-center">{{dt.nama}}</td>
                      <td class="w-table__cell text-center">

                        <w-radios
                          v-model="dt.status"
                          :items="penyakit_list"
                          inline
                          :disabled="data.lkp_status_id == 30 || data.lkp_status_id == 18 || data.lkp_status_id == 21"
                          :validators="[form.hantar == 1 || form.hantar == 3 ? validators.required : []]"
                          color="blue-dark3"
                        />

                        <!-- <w-radios
                        v-model="dt.status"
                        :items="penyakit_list"
                        inline
                        :disabled="data.lkp_status_id == 26 || data.lkp_status_id == 18 || data.lkp_status_id == 21 "
                        :validators="[validators.required]"
                        color="blue-dark3"
                      /> --></td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </w-form>
      </w-card>
      <br>
      <template  v-if="$zutil.anyRole(['1','6'])" >
      <w-card 
           title-class="blue-dark4--bg white" 
           style="font-size: 13px;" 
           :title="'Pegawai Penyemak'"
         >
           <w-form 
             ref="zform" 
             v-model="valid" 
             v-model:errors-count="errorsCount" 
             @submit.prevent="validateForm" 
             @success="success"
           >
             <template #title>
               Pegawai Penyemak
             </template>
             <div class="w-table-wrap" style="max-height: 400px; padding: 1rem;">
               <span>Nama : {{data.nama_semakan}}</span>
             </div>
           </w-form>
         </w-card>
      </template>
      <br>
       <!-- <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'SARANAN PENYEMAK'">
           <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
             <template #title>
               SARANAN PENYEMAK
             </template>
             <div class="w-table-wrap" style="max-height: 400px;">
               <div class="table-profil-scrol">
                 <table class="w-table" color="light">
                   <thead>
                     <tr>
                       <th class="w-table__header text-center" width="1%">BIL</th>
                       <th class="w-table__header text-center">KATEGORI</th>
                       <th class="w-table__header text-left">KETERANGAN</th>
                       <template v-if="data.lkp_status_id == 34">
                           <th class="w-table__header text-center">(PILIH SATU SAHAJA)</th>
                        </template>
                     </tr>
                   </thead>
                   <tbody>
                     <template v-if="(data.lkp_status_id == 26 || data.lkp_status_id == 18 || data.lkp_status_id == 21 )">
                        <template v-for="(dt, ind) in data.baka_saranan_list" :key="dt.id">
                           <template v-if="form.lkp_baka_saranan_id == dt.id ">
                              <tr class="w-table__row">
                                 <td class="w-table__cell text-center">{{ind+1}}</td>
                                 <td class="w-table__cell text-center">{{dt.nama}}</td>
                                 <td class="w-table__cell text-left" v-html="nl2br(dt.keterangan)"></td>
                              </tr>
                           </template>
                        </template>
                     </template>
                     <template v-else>
                        <template v-for="(dt, ind) in data.baka_saranan_list" :key="dt.id">
                           <tr class="w-table__row">
                              <td class="w-table__cell text-center">{{ind+1}}</td>
                              <td class="w-table__cell text-center">{{dt.nama}}</td>
                              <td class="w-table__cell text-left" v-html="nl2br(dt.keterangan)"></td>
                              <td class="w-table__cell text-center">
                              <div class="title4 mb2"></div>
                              <w-checkbox :model-value="form.lkp_baka_saranan_id === dt.id" 
                                 @update:model-value="val => klickPi(dt, val)"></w-checkbox>
                              </td>
                           </tr>
                        </template>
                     </template>
                   </tbody>
                 </table>
                 <br>
                 <span> CATATAN : {{form.catatan}}</span><br>
               </div>
             </div>
           </w-form>
         </w-card> -->
         <template  v-if="$zutil.anyRole(['1','6'])" >
         <w-card 
                 title-class="blue-dark4--bg white" 
                 style="font-size: 13px;" 
                 :title="'STATUS PERMOHONAN'"
               >
                 <w-form 
                   ref="zform" 
                   v-model="valid" 
                   v-model:errors-count="errorsCount" 
                   @submit.prevent="validateForm" 
                   @success="success"
                 >
                   <template #title>
                     STATUS
                   </template>

                   <div class="w-table-wrap" style="max-height: 400px; padding: 1rem;">
                     
                     <!-- <w-radios
                        v-model="form.lkp_status_id"
                        :items="lkp_status"
                        inline
                        :validators="[validators.required]"
                        color="blue-dark3"
                      /> -->
                      <w-radios
                        v-model="form.lkp_status_id"
                        :items="lkp_status"
                        inline
                        :disabled="data.lkp_status_id == 18 || data.lkp_status_id == 21"
                        :validators="[validators.required]"
                        color="blue-dark3"
                      />
                   </div>
                 </w-form>
               </w-card>
            </template>
            <br>
          <!--  <w-card 
                 title-class="blue-dark4--bg white" 
                 style="font-size: 13px;" 
                 :title="'CATATAN'"
               >
                 <w-form 
                   ref="zform" 
                   v-model="valid" 
                   v-model:errors-count="errorsCount" 
                   @submit.prevent="validateForm" 
                   @success="success"
                 >
                   <template #title>
                     CATATAN
                   </template>

                   <div class="w-table-wrap" style="max-height: 400px; padding: 1rem;">
                     <template v-if="data.lkp_status_id == 34 || data.lkp_status_id == 26 && $zutil.anyRole(['4'])">
                        <w-input 
                          label="Catatan" 
                          type="textarea"
                          v-model="form.catatan" 
                          :validators="[validators.required]" 
                          :disabled="data.lkp_status_id == 26 || data.lkp_status_id == 18"
                          outlined 
                          rows="4"
                        />
                     </template>
                     <template v-else>
                        <w-input 
                          label="Catatan" 
                          type="textarea"
                          v-model="form.catatan_semakan" 
                          :disabled="data.lkp_status_id == 21 || data.lkp_status_id == 18"
                          outlined 
                          rows="4"
                        />
                     </template>
                   </div>
                 </w-form>
               </w-card> -->


               <w-card 
                    title-class="blue-dark4--bg white" 
                    style="font-size: 13px;" 
                    :title="'CATATAN'"
                  >
                    <w-form 
                      ref="zform" 
                      v-model="valid" 
                      v-model:errors-count="errorsCount" 
                      @submit.prevent="validateFormData" 
                      @success="success"
                    >
                      <template #title>
                        CATATAN
                      </template>

                      <div class="w-table-wrap" style="max-height: 400px; padding: 1rem;">
                        <template v-if="data.lkp_status_id == 34 || data.lkp_status_id == 30 && $zutil.anyRole(['4'])">
                          <w-input 
                            label="Catatan" 
                            type="textarea"
                            v-model="form.catatan" 
                            :validators="[
                              data.lkp_status_id == 21 ? validators.required : null
                            ]"
                            :disabled="data.lkp_status_id == 30 || data.lkp_status_id == 18"
                            outlined 
                            rows="4"
                          />
                        </template>
                        <template v-else>
                          <w-input 
                            label="Catatan" 
                            type="textarea"
                            v-model="form.catatan_semakan" 
                            :validators="[
                            form.lkp_status_id == 21 ? validators.required : null
                            ]"
                            outlined 
                            rows="4"
                            />
                            
                         
                          <!-- <w-input 
                            label="Catatan" 
                            type="textarea"
                            v-model="form.catatan_semakan" 
                            :validators="[
                              data.lkp_status_id == 21 ? validators.required : null
                            ]"
                            :disabled="data.lkp_status_id == 21 || data.lkp_status_id == 18"
                            outlined 
                            rows="4"
                          /> -->
                        </template>
                      </div>
                    </w-form>
                  </w-card>
               <w-flex class="mt3" wrap align-center justify-end v-if="data.lkp_status_id == 34 && $zutil.anyRole(['4']) ">
                  <w-button class="my1" :loading="form.submitted && !form.sent" @click="send(2)">
                       <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
                  </w-button>
                  &nbsp;
                  <w-button class="my1" bg-color="success" type="submit" :loading="form.submitted && !form.sent" @click="send(1)">
                     <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
                  </w-button>
               </w-flex>
               <w-flex class="mt3" wrap align-center justify-end  v-if="$zutil.anyRole(['1','6']) && data.lkp_status_id == 30">
                  <w-button class="my1" bg-color="success" type="submit" :loading="form.submitted && !form.sent" @click="send(form.lkp_status_id)"> <!-- 3 hantar semakan -->
                     <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
                  </w-button>
               </w-flex>
             <div class="mt2 text-left">
          <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
        </div>
      </div>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource';
import VueQrcode from 'vue-qrcode'

export default {
  extends: ZResource,
  components: {
    VueQrcode,
  },
  props: {
    id: [Array, Object, String],

  },
  data() {
    return {
      // resourceurl: 'baka.permohonan',
      resourceurl: this.api_service + "baka",
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Baka Permohonan', route: '/baka' },
        { label: 'Permohonan', route: '/baka/permohonan' },
        { label: 'Papar', route: '/baka/permohonan/'+this.id },
      ],

      title : '',
      form : {
        id : 0,
        catatan :'',
        penyakit : '',
        lkp_baka_saranan_id : '',
        catatan_semakan: '',
        hantar : 0,
        penyakit: {},
        submitted: false,
      sent: false,
      valid: false
        
      },
      activeTab : 0,
      ternakan_list:[],
      lkp_status : [],
      baka_dokumen_list:[],
      baka_saranan_list:[],
      penyakit_list:[
        {value: 1, label: "Positif"},
        {value: 2, label: "Negatif"},
        {value: 3, label: "Tiada Tanda Klinikal"},
      ],
    }
  },
  validators: {
  
  validatePenyakitList: (value, context) => {
    
    if (context.form.hantar !== 1 && context.form.hantar !== 3) {
      return true; 
    }
    
    
    const penyakitList = context.data.baka_penyakit_list || [];
    const hasUnselected = penyakitList.some(item => !item.status);
    
    if (hasUnselected) {
      return "Sila pilih status untuk semua penyakit";
    }
    
    return true;
  }
},
  methods: {

    tutup(){
         this.$inertia.visit(window.route('baka.index'));
       },

     nl2br(text) {
       if (!text) return '';
       return text.replace(/\\n/g, '<br>');
     },


   send(hantar) {
    this.form.hantar = hantar;

    // If hantar == 2, call onSuccessSimpan
    if (this.form.hantar === 2) {
      this.onSuccessSimpan();

    // Else if hantar is something else (and maybe not undefined/null)
    } else if (this.form.hantar) {
      this.validateFormData();

    // Fallback / unexpected value
    } else {
      this.validateFormData();
    }
  },

 validateFormData() {

      // alert(this.form.hantar);
      this.loading=true;
      let isValid = true;
      let jumlah_lulus = 0;
         // if(this.data.id > 0){ 

          if (this.form.hantar == 1) {

            for (var i in this.data.ternakan_list) {
               if (this.data.ternakan_list[i].lkp_baka_saranan_id == null) {
                  this.$zutil.notify("Pastikan Status Penyemak sudah terisi", false);
                  isValid = false;
                  break;
               }
            };

          }else{

             for (var i in this.data.ternakan_list) {
               if (this.data.ternakan_list[i].lkp_baka_saranan_pelulus_id == null) {
                  this.$zutil.notify("Pastikan Status Pelulus sudah terisi", false);
                  isValid = false;
                  break;
               }
            };

             if (this.form.lkp_status_id === 21 && this.form.catatan_semakan == null) {
                  this.$zutil.notify("Catatan wajib diisi", false);
                  this.loading = false;
                  return false;
              }

          }

          if (!this.form.hantar) {
            this.$zutil.notify("Pastikan Status Permohonan sudah terisi", false);
            this.loading = false;
            return false;
          }

         

         // }
      if (!isValid) {
        // this.$zutil.notify("Pastikan data sudah Permohonan BSE/FE sudah Selesai", false);
        this.loading=false;
        return false;
      }
      // this.datas.hantar = 1;
      this.onSuccess();
    },



    // onSuccess(){
    //   // alert(this.data.id);

    //   // this.form.ternakan_list = this.ternakan_list;
    //   this.form.baka_id = this.data.id;
    //   this.form.baka_penyakit_list = this.data.baka_penyakit_list;
    //   this.form.baka_dokumen_list = this.data.baka_dokumen_list;
    //        this.$zcomm.post(this.resourceurl + '/simpan_baka', this.form)
    //               .then(res => {
    //                  if(this.form.hantar == 1 || this.form.hantar == 3){
    //                     this.$zutil.notify("Baka berjaya dihantar", true);
    //                     this.$inertia.visit(this.$route('baka.index', res.id));
    //                  }else{
    //                     this.$zutil.notify("Baka berjaya Disimpan", true);
    //                     this.$inertia.visit(this.$page.url)
    //                  }
    //               })
    //               .catch(error => {
    //                  this.$zutil.notify("Ralat ketika menghantar Baka", false);
    //                  console.error(error);
    //               })
    //               .finally(() => {
    //                  this.loading = false;
    //               });
      
    //   },
     onSuccessSimpan() {
           
                 this.form.baka_id = this.data.id;
                 this.form.baka_penyakit_list = this.data.baka_penyakit_list;
                 this.form.baka_dokumen_list = this.data.baka_dokumen_list;

                 this.$zcomm.post(this.resourceurl + '/simpan_baka', this.form)
                 .then(res => {
                    this.$zutil.notify("Baka berjaya Disimpan", true);
                    this.$inertia.visit(this.$page.url)
                  })
                 .catch(error => {
                    this.$zutil.notify("Ralat ketika menghantar Baka", false);
                    console.error(error);
                  })
                 .finally(() => {
                    this.loading = false;
                  });
         },

      onSuccess() {
           // if (this.form.hantar != 2) {
             const hasUnselected = this.data.baka_penyakit_list.some(item => !item.status);
             if (hasUnselected) {
               this.$zutil.notify("Sila pilih status untuk semua penyakit", false);
               return;
             }
             this.$swal({
                title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
               type: 'warning',
               showCancelButton: true,
               confirmButtonColor: '#3085d6',
               cancelButtonColor: '#d33',
               confirmButtonText: 'Ya',
               cancelButtonText: 'Tidak'
             }).then((result) => {
               if (result.value) {

                 this.form.baka_id = this.data.id;
                 this.form.baka_penyakit_list = this.data.baka_penyakit_list;
                 this.form.baka_dokumen_list = this.data.baka_dokumen_list;

                 this.$zcomm.post(this.resourceurl + '/simpan_baka', this.form)
                 .then(res => {
                    this.$zutil.notify("Baka berjaya dihantar", true);
                    this.$inertia.visit(this.$route('baka.index', res.id));
                  })
                 .catch(error => {
                    this.$zutil.notify("Ralat ketika menghantar Baka", false);
                    console.error(error);
                  })
                 .finally(() => {
                    this.loading = false;
                  });
               }else{ }
             })
           // }

           
         },

         getStatus(){
         this.$zcomm.get(this.api_service + 'lookup/status_mohon', {}).then(res => {
           this.lkp_status = res
         })
       },


      getData() {
      this.$zcomm.get(this.api_service + 'baka/show/'+this.id, {}).then(res => {
        this.data = res
        this.form.catatan = this.data.catatan ?? null;
        this.form.catatan_semakan = this.data.catatan_semakan ?? null;
        if(this.data.lkp_status_id == 18 ||this.data.lkp_status_id == 21){
           this.form.lkp_status_id = this.data.lkp_status_id ?? null;
        }
        if (this.data.ternakan_list) {
          this.data.ternakan_list.forEach(item => {
            if (item.pilih === undefined) {
              this.$set(item, 'pilih', false)
            }
          })
          if (this.data.lkp_baka_saranan_id) {
            this.data.baka_saranan_list.forEach(item => {
               if(item.lkp_baka_saranan_id == item.id){
               this.klickPi(item, item.lkp_baka_saranan_id);
               return;
               }
            });
          }
        }
        
      })
    },
    
  //   klickPi(item) {
  //   this.data.baka_saranan_list.forEach(dt => {
  //     if (dt.id !== item.id) {
  //       dt.pilih = false;
  //     }
  //   });
  // },
  klickPi(item, isChecked) {
  if (isChecked) {
    // Tandai hanya yang dipilih
    this.data.baka_saranan_list.forEach(dt => {
      dt.pilih = dt.id === item.id;
    });
    // Simpan id yang dipilih
    this.form.lkp_baka_saranan_id = item.id;
  } else {
    // Kalau tidak dicentang, hapus pilihan
    item.pilih = false;
    this.form.lkp_baka_saranan_id = null;
  }
},
  cetak(id)
  {
      window.open('/baka/cetak/' + id, '_blank');
  },


  validateForm() {
    return this.$refs.zform.validate();
  },

  url_kes(kes) {
      this.$zcomm.get(this.api_service + 'integrasi/kes/'+kes, {}).then(res => {
          res.urls.forEach(url => {
             window.open(url, "_blank")
          })
    
      })
       .catch(err => {
            this.$zutil.notify("no_kes: Tiada dalam sistem MyVetLab", false);
            console.error(err);
        });
   },


  },
  watch: {

  },
  mounted() {
    this.getData();
    this.getStatus();


  },
}
</script>

<style>
.tindakan-cell {
  min-width: 120px; 
}

.button-group {
  display: flex;
  gap: 4px; 
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap; 
}

.action-button {
  padding: 4px 8px !important; 
  margin: 0 !important; 
  min-width: 32px;
}

@media screen and (max-width: 1366px) {
  .action-button .w-icon {
    font-size: 14px !important;
  }
  
  .action-button {
    padding: 2px 6px !important;
  }
}

.abnormal-input {
  margin-top: 1rem;
}


.input-hint {
  color: black;
  font-size: 1.1em;
  display: block;
  margin-top: 8px;
  margin-bottom: 8px;
}

.no_permohonan {
    font-weight: bold;
    font-size: 16px;
    line-height: 30px;
}
table{
  width: 100%;
}
</style>
